@if (status === 2) {
  <zwi-back-headline (navigateBack)="back()">Account</zwi-back-headline>
  <zwi-email-sent-message [email]="form.get('email')?.getRawValue()"></zwi-email-sent-message>
} @else {
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="fill" class="zwi-vertical-form__md-field" [ngClass]="{'zwi-form-field--full': isMobile()}">
      <mat-label>Email address</mat-label>
      <input matInput formControlName="email">
      <mat-error>
        @if (form.get('email')?.errors?.required) {
          {{ formError.getErrorMessage('email', 'required') }}
        }
        @if (form.get('email')?.errors?.email) {
          {{ formError.getErrorMessage('email', 'email') }}
        }
        @if (form.get('email')?.errors?.currentEmail) {
          {{ formError.getErrorMessage('email', 'currentEmail') }}
        }
        @if (form.get('email')?.errors?.emailTaken) {
          {{ formError.getErrorMessage('email', 'emailTaken') }}
        }
      </mat-error>
    </mat-form-field>
    <zwi-widget>
      <button mat-flat-button color="primary">Save changes</button>
    </zwi-widget>
  </form>
}
